var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.data.visible
    ? _c("div", {}, [
        _c(
          "div",
          {
            staticClass: "modal fade modalGallery show",
            attrs: {
              id: "modalGallery",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "referenceGallery",
            },
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-label": "Close",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.closeModal()
                          },
                        },
                      },
                      [_c("span", { staticClass: "mdi mdi-close" })]
                    ),
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "project-modal-gallery modal-gallery-slick-slider",
                        attrs: { id: "gallery" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "modal-gallery-slick-slider-list draggable",
                          },
                          _vm._l(_vm.images, function (image, index) {
                            return _c(
                              "div",
                              { staticClass: "modal-gallery-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-gallery-image-container d-flex justify-content-center align-items-center",
                                  },
                                  [
                                    typeof image.copyright != "undefined" &&
                                    image.copyright != "" &&
                                    image.copyright != null
                                      ? _c("img", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.bottom",
                                              value: image.copyright,
                                              expression: "image.copyright",
                                              modifiers: { bottom: true },
                                            },
                                          ],
                                          attrs: {
                                            "data-lazy": image.webImage,
                                            alt: "",
                                          },
                                        })
                                      : _c("img", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.bottom",
                                              value: image.copyright,
                                              expression: "image.copyright",
                                              modifiers: { bottom: true },
                                            },
                                          ],
                                          attrs: {
                                            "data-lazy": image.webImage,
                                            alt: "",
                                          },
                                        }),
                                  ]
                                ),
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(index + 1) +
                                      "/" +
                                      _vm._s(_vm.images.length) +
                                      "\n                  "
                                  ),
                                  typeof image.caption != "undefined" &&
                                  image.caption != ""
                                    ? _c("span", [
                                        _vm._v(" - " + _vm._s(image.caption)),
                                      ])
                                    : _vm._e(),
                                  typeof image.copyright != "undefined" &&
                                  image.copyright != null &&
                                  image.copyright != ""
                                    ? _c("span", [
                                        _vm._v(
                                          " (" +
                                            _vm._s(
                                              _vm.trans(
                                                "lifechallenge_copyright"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(image.copyright) +
                                            ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
        _c("div", {
          staticClass: "modal-backdrop fade show modalGallery-modal-backdrop",
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }